import * as React from 'react';
import { IChannel } from '../../../../data/api/models';

interface IFooterProps {
  channel?: IChannel;
}

export default class Footer extends React.Component<IFooterProps, any> {
  public render() {
    const { channel } = this.props;

    return (
      <footer>
        <div className="container">
          {channel.footer}
        </div>
      </footer>
    );
  }
}
